import {BrowserRouter,Navigate, Route,Routes} from "react-router-dom";
import DefaultNavbar from "./LoginNav";
import SimpleFooter from "./LoginFooter";
import LoginForm from "./LoginForm";
import React from "react";

const LoginRoute = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage/>}/>
        <Route path="*" element={<Navigate to="/login" replace/>}/>
      </Routes>
    </BrowserRouter>
  );
};

const LoginPage = () => {

  return (
    <LoginPageWrapper>
      {/*<DefaultNavbar/>*/}
      <LoginContainer>
        <LoginForm/>
      </LoginContainer>
      <SimpleFooter/>
    </LoginPageWrapper>
  );
};

export default LoginRoute;


export function LoginPageWrapper({children}) {
  return (
    <div className="w-screen min-h-screen relative flex flex-col justify-center items-center bg-rand-100 px-4 py-6">
      {children}
    </div>
  );
}

export function LoginContainer({children}) {
  return (
    <div className="max-w-sm w-full">{children}</div>
  );
}